import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-navtoggle', 'toggleMenu', 'Включить меню');
Labels.set('ui-navtoggle', 'closeMenu', 'Закрыть меню');
Labels.set('ui-navtoggle', 'close', 'Закрыть');
